module.exports = __webpack_public_path__ + "img/zamonuz.9e36626c.png";